export default __webpack_public_path__ + "static/media/skysports-logo.bf85f972.png";